import { AppState } from '../store'

export const membershipSelector = (state: AppState): any => {
  return (state && state.memberships) || []
}
